import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "flowbite-react";

const NavbarVoltar = () => {
  const navigate = useNavigate();
  return (
    <header>
      <Navbar fluid rounded className="bg-white shadow-md">
        <div className="lg:flex">
          <Link
            onClick={() => navigate(-1)}
            className="text-sm font-semibold text-gray-900"
          >
            ← Voltar
          </Link>
        </div>
      </Navbar>
    </header>
  )
}
export default NavbarVoltar;
